import { render, staticRenderFns } from "./MenuLayout.vue?vue&type=template&id=1bd908e3&scoped=true&"
import script from "./MenuLayout.vue?vue&type=script&lang=js&"
export * from "./MenuLayout.vue?vue&type=script&lang=js&"
import style0 from "./MenuLayout.vue?vue&type=style&index=0&id=1bd908e3&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd908e3",
  null
  
)

export default component.exports